export default "__VITE_ASSET__2ee172c3__"